export default "__VITE_ASSET__CJXMrcJg__"